import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { Observable, map } from 'rxjs';

import { MobileDeviceService } from '@app/services/mobile-device.service';

@Component({
  selector: 'app-alert-created-edited-modal',
  templateUrl: './alert-created-edited-modal.component.html',
  styleUrls: ['./alert-created-edited-modal.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AlertCreatedEditedModalComponent {

  @Input() isCreated: boolean = false;

  @Output() toggleNotification: EventEmitter<void> = new EventEmitter<void>();

  private readonly CONFIRM_CREATED_TITLE: string = 'GENERAL_WIDGET_MODULE.ALERTS.CONFIRM.CREATED';
  private readonly CONFIRM_EDITED_TITLE: string = 'GENERAL_WIDGET_MODULE.ALERTS.CONFIRM.EDITED';
  private readonly MODAL_WIDTH_MOBILE: number = 343;
  private readonly MODAL_WIDTH_DESKTOP: number = 480;

  public readonly ALERT_NOTIFICATION: string = 'ilustra_alert_bell.png';

  constructor(
    private readonly mobileDeviceService: MobileDeviceService,
  ) { }

  get modalWidth$(): Observable<number> {
    return this.mobileDeviceService.isMobileDevice$.pipe(
      map(isMobile => {
        return isMobile ? this.MODAL_WIDTH_MOBILE : this.MODAL_WIDTH_DESKTOP;
      })
    );
  }

  get titleKey(): string {
    return this.isCreated ? this.CONFIRM_CREATED_TITLE : this.CONFIRM_EDITED_TITLE;
  }

}
